import classNames from 'classnames'

import type { IconTypes } from '~/components/atoms/Icon/Icon'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './Badge.module.css'

export interface BadgeProps {
  type?: 'trusted' | 'accredited'
  isDark?: boolean
  isLarge?: boolean
}

export default function Badge({
  type = 'trusted',
  isDark = false,
  isLarge = false,
}: BadgeProps) {
  const variants = {
    trusted: {
      title: 'Trusted Partner',
      icon: 'TrustedPartner',
    },
    accredited: {
      title: 'Accredited Partner',
      icon: 'AccreditedPartnerBadge',
    },
  }

  const mainVariant = variants[type]

  return (
    <>
      <div
        className={classNames(
          styles.base,
          isDark && styles.baseDark,
          isLarge && styles.baseLarge,
          styles[`base${type}`]
        )}
      >
        <div className={styles.icon}>
          <Icon fill="#ffff" type={mainVariant.icon as IconTypes} />
        </div>
        <Text size={TextSizes.bodySml} className={styles.text} uppercase>
          {mainVariant.title}
        </Text>
      </div>
    </>
  )
}
